<template lang="pug">
  .container.compere-block
    .old-block
      input-creator(
        disabled
        tip-placement="right"
        :value="oldValue"
        :tipWidth="tipWidth"
        :label="labelForOld"
        :filter="filter"
        :data-type="filter.data_type"
        :tip="explanation")
    .new-block(:class="{'new-block__error-box': hasError}")
      input-creator(
        :disabled="disabled"
        :tip="proposeExplanation || explanation"
        tip-placement="right"
        :tipWidth="tipWidth"
        :data-type="filter.data_type"
        :value="value"
        :filter="filter"
        :label="label"
        :autocompleteEntity="autocompleteEntity"
        :rules="rules"
        :class="{'error-input': hasError}"
        @set-enum-value="({value}) => $emit('change', value)"
        @set-input-value="({value}) => $emit('change', value)")
      p.error(v-if="errorMsg") {{errorMsg}}
      p.error(v-else-if="sameValueErr") New value cannot equal old
</template>
<script>
import { mapState, } from 'vuex'
import { findFilterById, } from '../../store/modules/search/helpers'
import { getFieldIdByPath, } from '../../utils/challenge'
import InputCreator from '../lei-components/inputs/InputCreator'
import { getExceptByPath, getGetValueByPath, getProperty, getTextByPath, getProposeTextByPath, } from '@/utils/challenge'
import { prepareFilterForChallenge, } from '@/store/modules/search/helpers'

export default {
  components: { InputCreator, },
  props: {
    oldValue: {
      type: [
        Array,
        Number,
        String,
        Object,
      ],
      default: '',
    },
    value: {
      type: [
        Array,
        Number,
        String,
        Object,
      ],
      default: '',
    },
    needTip: {
      type: Boolean,
      default: true,
    },
    tipWidth: {
      type: Number,
      default: 220,
    },
    jsonPath: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    labelForOld: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    sameValueAllowed: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filter () {
      let filter = findFilterById(this.filters, getFieldIdByPath(this.jsonPath))
      let exceptArray = getExceptByPath(this.jsonPath)
      return prepareFilterForChallenge({
        filter,
        oldValue: this.oldValue,
        exceptArray,
      })
    },
    explanation () {
      return this.needTip ? getTextByPath(this.jsonPath) : ''
    },
    proposeExplanation () {
      return this.needTip ? getProposeTextByPath(this.jsonPath) : ''
    },
    getValue () {
      return getGetValueByPath(this.jsonPath)
    },
    autocompleteEntity () {
      return getProperty(this.jsonPath, 'autocompleteEntity')
    },
    hasError () {
      return !!this.errorMsg || this.sameValueErr
    },
    sameValueErr () {
      if (this.sameValueAllowed) {
        return false
      } else {
        return !!this.value && this.value === this.oldValue
      }
    },

    ...mapState('search', [ 'filters', ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .container.compere-block
    flex-direction column
    margin-bottom 0

    .old-block, .new-block
      display flex
      flex 1
      margin 0 0 25px

    .new-block
      flex-direction column
      &__error-box
        margin 0

    &:last-child
      .old-block, .new-block
        margin-bottom 0

  @media (min-width: $laptop)
    .container.compere-block
      flex-direction row

      .old-block
        margin-right 20px

      .new-block
        margin-left 20px

</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeCompareBlock.vue